<template>
  <div class="connections-with-regions">
    <div class="connections-with-regions__header">
      <p class="connections-with-regions__header-title">
        Всего регионов РФ <span>{{ getFerRegionsTradeCountOfCountry }}</span>
      </p>
      <div class="connections-with-regions__search d-flex align-items-center">
        <p class="mr-6">Источник: ЕХД</p>

        <Multiselect
          class="select-country-analytic"
          label="label"
          :searchable="true"
          v-model="year"
          valueProp="value"
          trackBy="label"
          noResultsText="Ничего не найдено."
          noOptionsText="Список пуст."
          :options="getYearOptions"
          :canClear="false"
          @select="loadMapData"
        />
      </div>
    </div>
    <div class="mb-20">
      <EChartsHorizontalBar
        :labels="chartLabels"
        :dataset="chartDataset"
        :showLegend="true"
        :height="chartHeight"
        emptyMessage="Данные отсутствуют"
        :valueFractionDigits="1"
        :xAxisMaxRatio="1.2"
        :categoryLabelWidth="280"
      />
    </div>

    <div v-if="!isShowAll" class="d-flex">
      <div class="connections-with-regions__show-btn" @click="showMore">
        Показать еще
        <IconComponent name="plus-mini" class="connections-with-regions__show-btn-icon" />
      </div>
      <div class="connections-with-regions__show-btn" @click="showAll">
        Показать все <IconComponent name="plus-mini" class="connections-with-regions__show-btn-icon" />
      </div>
    </div>
    <div v-else-if="isShowHideBtn" class="connections-with-regions__show-btn" @click="hideChart">
      Скрыть
      <IconComponent name="arrowCurrentColor" class="icon--right connections-with-regions__hide-btn-icon" />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import Multiselect from '@vueform/multiselect';

  import IconComponent from '@/common/ui/IconComponent.vue';

  import EChartsHorizontalBar from '@/components/ChartComponents/apacheEcharts/EChartsHorizontalBar.vue';

  import { BASE_VES_ACTIONS_NAME, BASE_VES_GETTERS_NAME } from '@/modules/ves/store/base/name';

  import { COUNTRY_ANALYTICS_ACTIONS_NAME, COUNTRY_ANALYTICS_GETTERS_NAME } from '../../store/analytics/directoryNames';
  import { CONNECTIONS_WITH_REGIONS_CHART_LIMIT } from '../../utils/constants';

  export default {
    name: 'ConnectionsWithRegions',
    components: {
      EChartsHorizontalBar,
      Multiselect,
      IconComponent,
    },
    props: {
      countryId: {
        type: Number,
        required: true,
      },
    },
    data: () => ({
      year: null,
      limit: CONNECTIONS_WITH_REGIONS_CHART_LIMIT,
      isShowAll: false,
      isShowHideBtn: false,
      chartHeight: 600,
    }),
    created() {
      this.loadData();
    },
    computed: {
      ...mapGetters({
        getYearOptions: BASE_VES_GETTERS_NAME.getYearOptions,
        getFerRegionsTradeValues: COUNTRY_ANALYTICS_GETTERS_NAME.getFerRegionsTradeValues,
        getFerRegionsTradeCountOfCountry: COUNTRY_ANALYTICS_GETTERS_NAME.getFerRegionsTradeCountOfCountry,
      }),
      chartLabels() {
        if (this.getFerRegionsTradeValues.tradeData == null) return [];

        return Object.keys(this.getFerRegionsTradeValues.tradeData).map(
          (regionName, index) => `${index + 1}  ${regionName}`,
        );
      },
      chartDataset() {
        if (this.getFerRegionsTradeValues.tradeData == null) return [];

        const tradeEntries = Object.values(this.getFerRegionsTradeValues.tradeData);

        return [
          {
            data: tradeEntries.map(({ import: importItem }) => Number(importItem.value)),
            color: '#01A39D',
            label: 'Импорт, млн ₽',
          },
          {
            data: tradeEntries.map(({ export: exportItem }) => Number(exportItem.value)),
            color: '#D9D9D9',
            label: 'Экспорт, млн ₽',
          },
        ];
      },
    },

    watch: {
      countryId: {
        handler() {
          this.loadMapData();
        },
      },
    },
    methods: {
      ...mapActions({
        getYearLast: BASE_VES_ACTIONS_NAME.getYearLast,
        getFerRegionsTradeValue: COUNTRY_ANALYTICS_ACTIONS_NAME.getFerRegionsTradeValue,
        getFerRegionsTradeCountryCount: COUNTRY_ANALYTICS_ACTIONS_NAME.getFerRegionsTradeCountryCount,
      }),
      async loadData() {
        const yearsResponse = await this.getYearLast();

        if (yearsResponse.success) {
          this.year = this.getYearOptions[this.getYearOptions.length - 1].value;

          this.loadMapData();
        }
      },

      async loadMapData() {
        this.limit = CONNECTIONS_WITH_REGIONS_CHART_LIMIT;
        await this.fetchFerRegionsTradeValue(this.limit);
        await this.fetchFerRegionsTradeCountryCount();
        this.isShowAll = this.limit >= this.getFerRegionsTradeCountOfCountry;
        this.resolveChartHeight(this.limit);
      },

      async fetchFerRegionsTradeValue(limit) {
        await this.getFerRegionsTradeValue({ countryId: this.countryId, year: this.year, limit });
      },

      async fetchFerRegionsTradeCountryCount() {
        await this.getFerRegionsTradeCountryCount({ countryId: this.countryId, year: this.year });
      },

      async showMore() {
        this.limit += CONNECTIONS_WITH_REGIONS_CHART_LIMIT;
        await this.fetchFerRegionsTradeValue(this.limit);
        if (this.limit >= this.getFerRegionsTradeCountOfCountry) {
          this.isShowAll = true;
          this.isShowHideBtn = true;
        }
        this.resolveChartHeight(this.limit);
      },

      async showAll() {
        await this.fetchFerRegionsTradeValue(this.getFerRegionsTradeCountOfCountry);
        this.isShowAll = true;
        this.isShowHideBtn = true;
        this.resolveChartHeight(this.getFerRegionsTradeCountOfCountry);
      },

      async hideChart() {
        this.limit = CONNECTIONS_WITH_REGIONS_CHART_LIMIT;
        await this.loadMapData();
        this.isShowAll = false;
        this.isShowHideBtn = false;
        this.resolveChartHeight(this.limit);
      },
      resolveChartHeight(limit) {
        this.chartHeight = (limit / CONNECTIONS_WITH_REGIONS_CHART_LIMIT) * 600;
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '../../styles/countryAnalyticsMultiselect.scss';

  .connections-with-regions {
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
      flex-wrap: wrap;
      gap: 8px;
    }
    &__header-title {
      color: $base;
      font: $fira-20-M;
      span {
        background: linear-gradient(90deg, $blue 0%, $green 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        display: inline-block;
        margin-left: 5px;
      }
    }
    &__search {
      display: flex;
      align-items: center;
      p {
        font: $fira-16;
        color: $base;
      }
    }
    &__show-btn {
      display: flex;
      align-items: center;
      font-family: 'Fira Sans';
      font-size: 15px;
      line-height: 20px;
      text-align: left;
      color: $green;
      cursor: pointer;

      &:first-of-type {
        margin-right: 20px;
      }
    }

    &__show-btn-icon {
      width: 14px;
      margin-left: 5px;
    }
    &__hide-btn-icon {
      transform: rotate(180deg);
      margin: 0 5px 3px;
    }
  }

  .select-country-analytic::v-deep {
    width: 150px !important;
    input:focus {
      border: unset;
      border-bottom: 1px solid $green;
    }
  }
</style>
